module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOCAYAAAAvxDzwAAAAm0lEQVQ4T63T0Q2AIAwEULuBozCCbuJGjuBKjuAIOkFtCRgEigU0IX5gXqB3wvDDg4gLMSutGXo9h23kXLRMFxhhEwDszWAO49s2gRJmQdo09D7puIdmniXMg8igTYhmUEK/MA9y5JxSEdVgzwyDj7OoFnuFIqE1WJJyjHJR3Ti4tLZnX8EltYnQ0f0BKkzsYe01w1OLxa7tp0dvQHBwWTOxSnAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/pcImg/check.png
// module id = ctZz
// module chunks = 1